(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/terms-integrity/assets/javascripts/views/terms-docs.js') >= 0) return;  svs.modules.push('/modules/terms-integrity/assets/javascripts/views/terms-docs.js'); 
(function(Backbone, svs) {
  'use strict';

  svs.terms_integrity.views.TermsDocs = Backbone.Marionette.View.extend({
    tagName: 'div',
    id: 'terms',
    modelEvents: {
      change: 'render'
    },

    template: function(data) {
      return svs.terms_integrity.templates.terms_docs(data);
    },

    initialize: function() {
      svs.terms_integrity_logger.debug('svs.terms_integrity.views.TermsDocs - initialize');
    },

    onRender: function() {}
  });
})(Backbone, svs);

 })(window);